import Grid from "@mui/material/Unstable_Grid2/Grid2"
import ComboBox from "../../../../Components/ComboBox/ComboBox"

const AutoCompleteImovel = ({ imoveis, handleChangeImoveis, reset, newSx, defaultValueImovel, index }) => {
    return (
        <Grid data-index={`grid-${index}`} item xs={12}>
            {
                imoveis &&
                <ComboBox
                    name="imovel"
                    options={imoveis}
                    onChange={handleChangeImoveis}
                    newSx={{ width: newSx || '165px' }}
                    reset={reset}
                    defaultValue={defaultValueImovel}
                />
            }
        </Grid>
    )
}

export default AutoCompleteImovel
